export class CreateConveyanceConfigRequest {
  ConveyanceID: number;
  ConfigName: string;
  ConfigValue: string;
}
